<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div class="font-secondary">
                <h2>Create a study</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>First, give your study a name</h3>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
                <fieldset>
                  <div class="bigmi-input">
                    <input :class="nameClassObj" type="text" placeholder="My Study" v-model="formModel.name" autofocus>
                  </div>
                  <div class="pure-g">
                    <div class="pure-u-1" style="padding-top: 1em;">
                      <h3 class="pure-u-1">
                        Select the language your study will be in
                      </h3>
                      <Dropdown :selection=selectedLanguage>
                        <div class="option" v-for="lang in getAllLanguageOptions" @click="setLanguage(lang.langToken)">{{ lang.language }}</div>
                      </Dropdown>
                      <h6 class="pure-u-1">
                        Don't see your language?
                        <a href="mailto:support@bimileap.com">Contact us.</a>
                      </h6>
                    </div>
                  </div>
                  <div class="bigmi-checkbox" style="padding-top: 2em;">
                    <div class="input-container">
                      <input id="agree" type="checkbox" v-model="formModel.agreed">
                    </div>
                    <div>
                      <label for="agree" :class="agreedClassObj">
                        <span>I agree not to ask not accept information of a personal nature that could be used to identify the specific respondent.</span>
                      </label>
                      <label>
                        <span class="error" v-show="!isAgreedValid && touched">*Required Field</span>
                      </label>
                    </div>
                  </div>
                  <button type="submit" class="hidden-submit"></button>
                </fieldset>
                <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import {
      SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS,
      SET_IN_PROGRESS_STUDY_NAME,
      GET_IN_PROGRESS_STUDY_NAME,
      GET_NEXT_STUDY_STEP_ROUTE,
      UPDATE_STUDY,
      CSS_CLASS_NAME_INVALID,
      STUDY_MODE_4,
      SET_IN_PROGRESS_STUDY_MODE,
      GET_IN_PROGRESS_STUDY_LANGUAGE, SET_IN_PROGRESS_STUDY_LANGUAGE,
  } from '../../services/constants'
  import Dropdown from "../general/Dropdown"

  export default {
    name: 'NameTheStudy',
      components: {Dropdown},
      data() {
      return {
        formModel: null,
        touched: false,
      }
    },
    computed: {
      ...mapGetters([
        GET_NEXT_STUDY_STEP_ROUTE,
        GET_IN_PROGRESS_STUDY_NAME,
        GET_IN_PROGRESS_STUDY_LANGUAGE,
      ]),
      isNameValid() {
        return this.formModel.name.length > 0
      },
      showNameValidationUI() {
        return !this.isNameValid && this.touched
      },
      nameClassObj() {
        return {
          [CSS_CLASS_NAME_INVALID]: this.showNameValidationUI,
        }
      },
      isAgreedValid() {
        return this.formModel.agreed
      },
      showAgreedValidationUI() {
        return !this.isAgreedValid && this.touched
      },
      agreedClassObj() {
        return {
          [CSS_CLASS_NAME_INVALID]: this.showAgreedValidationUI,
        }
      },
      isFormModelValid() {
        return this.isNameValid && this.isAgreedValid
      },
      getAllLanguageOptions(){
        return [
            {language: "English", langToken: "en"},
            {language: "Chinese", langToken: "cn"},
            {language: "Hebrew", langToken: "he"},
            {language: "Indonesian", langToken: "id"},
            {language: "Spanish", langToken: "es"}
        ]
      },
      selectedLanguage(){
          return this.getAllLanguageOptions.filter( lang => {
              return lang.langToken === this.formModel.language
          })[0].language
      },
    },
    methods: {
      handleSubmit() {
        if (this.isFormModelValid) {
          this.$store.commit(SET_IN_PROGRESS_STUDY_NAME, this.formModel.name)
          this.$store.commit(SET_IN_PROGRESS_STUDY_LANGUAGE, this.formModel.language)
          this.$store.commit(SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS, this.formModel.agreed)
          this.$store.commit(SET_IN_PROGRESS_STUDY_MODE, STUDY_MODE_4)
          this.$store.dispatch(UPDATE_STUDY).then(() => {
            this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
          })
        }
      },
      resetFormModel() {
        const formObj = {
          name: '',
          language: '',
          agreed: false,
        }
        formObj.language = this[GET_IN_PROGRESS_STUDY_LANGUAGE]
        formObj.name = this[GET_IN_PROGRESS_STUDY_NAME]
        this.formModel = formObj
      },
      onTouched() {
        this.touched = true
      },
      setLanguage(lang){
        this.formModel.language = lang
      }
    },
    created() {
      this.resetFormModel()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .option {
    padding: 5px 20px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .option:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .container {
    height: 100%;
  }

  section {
    height: 100%;
  }

  .layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .child {
    width: 100%;
    max-width: 500px;
    margin: 1em;
  }

  h2, h3 {
    text-align: center;
  }

  h2 {
    color: $red-2;
  }

  h3 {
    color: $cyan-blue-3;
  }

  ::placeholder {
    color: $gray-3;
    opacity: 1;
  }

  .error{
    color: red;
  }

</style>
